import { render, staticRenderFns } from "./crm-requirement.vue?vue&type=template&id=1661674f&"
import script from "./crm-requirement.vue?vue&type=script&lang=js&"
export * from "./crm-requirement.vue?vue&type=script&lang=js&"
import style0 from "./crm-requirement.vue?vue&type=style&index=0&id=1661674f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports